/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpdateRemarksTemplateRequest
 */
export interface RequestUpdateRemarksTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateRemarksTemplateRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateRemarksTemplateRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateRemarksTemplateRequest
     */
    template: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateRemarksTemplateRequest
     */
    tenantId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateRemarksTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateRemarksTemplateRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestUpdateRemarksTemplateRequest interface.
 */
export function instanceOfRequestUpdateRemarksTemplateRequest(value: object): value is RequestUpdateRemarksTemplateRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('template' in value) || value['template'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestUpdateRemarksTemplateRequestFromJSON(json: any): RequestUpdateRemarksTemplateRequest {
    return RequestUpdateRemarksTemplateRequestFromJSONTyped(json, false);
}

export function RequestUpdateRemarksTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdateRemarksTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'id': json['id'],
        'template': json['template'],
        'tenantId': json['tenant_id'],
        'title': json['title'],
        'userId': json['user_id'],
    };
}

export function RequestUpdateRemarksTemplateRequestToJSON(json: any): RequestUpdateRemarksTemplateRequest {
    return RequestUpdateRemarksTemplateRequestToJSONTyped(json, false);
}

export function RequestUpdateRemarksTemplateRequestToJSONTyped(value?: RequestUpdateRemarksTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'id': value['id'],
        'template': value['template'],
        'tenant_id': value['tenantId'],
        'title': value['title'],
        'user_id': value['userId'],
    };
}

